'use client';

import { c as _c } from "react/compiler-runtime";
import { Facebook, Twitter, Linkedin, Link as LinkIcon } from 'lucide-react';
import { useState } from 'react';
interface ShareButtonsProps {
  title: string;
  url: string;
}
export function ShareButtons(t0) {
  const $ = _c(27);
  const {
    title,
    url
  } = t0;
  const [copied, setCopied] = useState(false);
  const t1 = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
  const t2 = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const t3 = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = {
      twitter: t1,
      facebook: t2,
      linkedin: t3
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const shareLinks = t4;
  let t5;
  if ($[4] !== url) {
    t5 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (t6) {
        const err = t6;
        console.error("Failed to copy:", err);
      }
    };
    $[4] = url;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const copyToClipboard = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-sm font-medium text-muted-foreground mr-2">Share:</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Twitter className="w-4 h-4" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== shareLinks.twitter) {
    t8 = <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-muted hover:bg-primary hover:text-white transition-colors" aria-label="Share on Twitter">{t7}</a>;
    $[8] = shareLinks.twitter;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Facebook className="w-4 h-4" />;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== shareLinks.facebook) {
    t10 = <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-muted hover:bg-primary hover:text-white transition-colors" aria-label="Share on Facebook">{t9}</a>;
    $[11] = shareLinks.facebook;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Linkedin className="w-4 h-4" />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== shareLinks.linkedin) {
    t12 = <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg bg-muted hover:bg-primary hover:text-white transition-colors" aria-label="Share on LinkedIn">{t11}</a>;
    $[14] = shareLinks.linkedin;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <LinkIcon className="w-4 h-4" />;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== copied) {
    t14 = copied && <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-foreground text-background text-xs px-2 py-1 rounded whitespace-nowrap">Copied!</span>;
    $[17] = copied;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== copyToClipboard || $[20] !== t14) {
    t15 = <button onClick={copyToClipboard} className="p-2 rounded-lg bg-muted hover:bg-primary hover:text-white transition-colors relative" aria-label="Copy link">{t13}{t14}</button>;
    $[19] = copyToClipboard;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t10 || $[23] !== t12 || $[24] !== t15 || $[25] !== t8) {
    t16 = <div className="flex items-center gap-2">{t6}{t8}{t10}{t12}{t15}</div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t15;
    $[25] = t8;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}